enum dotColorClass {
	ERROR = 'error-color',
	INFO = 'info-color',
	DEBUG = 'debug-color',
	DEFAULT = 'default-color'

}

export const dotColor = (itemValue: number): dotColorClass => {
	switch (itemValue) {
		case 8 :
			return dotColorClass.ERROR;
		case 2 :
			return dotColorClass.INFO;
		case 1 :
			return dotColorClass.DEBUG;
		default :
			return dotColorClass.DEFAULT;
	}
};
